import { useDispatch, useSelector } from "../../types/store";
import * as chatGPTReducer from "../../containers/ChatGPT/reducer";
import * as viewReducer from "../../containers/View/reducer";
import { keysOf } from "../../utils/collect";
import { isEnabled } from "../../utils/featureFlags";
import styles from "./style.module.css";
import Select from "react-select";
import { isOptionType, selectOnChangeWrapper } from "../../utils/select";
import ModelSelector from "./ModelSelector";
import { LineInput } from "../Inputs/LineInput";
import React from "react";
export const LLMOptions = ({ disableButtons, bpModelId }) => {
    const dispatch = useDispatch();
    const reports = useSelector((state) => viewReducer.getReports(state));
    const replayConvo = useSelector((state) => viewReducer.getConvoForReplay(state));
    const reportOptions = keysOf(replayConvo).map((reportId) => ({
        value: reportId,
        label: reports.find((r) => r.id === Number(reportId))?.name + " (" + replayConvo[reportId]?.length + " prompts)"
    }));
    const replayProjectIds = useSelector((state) => chatGPTReducer.getReplayProjectIds(state));
    return (React.createElement(React.Fragment, null,
        isEnabled("chat-template-replay") && (React.createElement("div", null,
            React.createElement("div", { className: styles.optionItemSelectorHeading },
                React.createElement("div", { className: styles.chatSettingsItemHeader, style: { marginBottom: "-2px" } }, "Auto-apply from project"),
                React.createElement("div", { className: styles.replaySelect },
                    React.createElement(Select, { options: reportOptions, onChange: (val) => isOptionType(val) ? dispatch(chatGPTReducer.updateReplayProjectIds(val)) : undefined, value: replayProjectIds }))),
            replayProjectIds?.value !== undefined && replayConvo?.[replayProjectIds?.value] !== undefined && (React.createElement("textarea", { className: styles.replayPromptTextArea, 
                /*
              value={
                replayProjectIds?.[0] !== undefined
                  ? replayProjectIds.reduce(
                      (a, b) =>
                        a +
                        [...replayConvo[b?.value]]
                          .reverse()
                          .reduce((a, b) => b?.userPrompt + "\n" + a, ""),
                      "",
                    )
                  : ""
              }
              */
                value: replayProjectIds?.value !== undefined && replayConvo?.[replayProjectIds?.value] !== undefined
                    ? [...replayConvo[replayProjectIds?.value]].reverse().reduce((a, b) => b?.userPrompt + "\n" + a, "")
                    : "" })))),
        React.createElement("div", { className: styles.optionItemSelectorHeading },
            React.createElement("div", { className: styles.chatSettingsItemHeader, style: {
                    marginBottom: "-2px",
                    whiteSpace: "nowrap"
                } }, "AI Model"),
            React.createElement("div", { className: styles.chatSettingsItemInput },
                React.createElement("div", null,
                    React.createElement(ModelSelector, { modelId: bpModelId, updateModelId: (val) => dispatch(chatGPTReducer.updateModelId(val)), hideIcons: true, isDisabled: disableButtons, onChange: selectOnChangeWrapper((val) => {
                            dispatch(chatGPTReducer.updateModelId(val));
                        }), isCreatable: true, selectorStyle: {
                            minWidth: "159px"
                        }, style: {
                            flexShrink: "1",
                            whiteSpace: "normal",
                            marginRight: "8px"
                        } })),
                isEnabled("chat-model-string-input") && (React.createElement("div", { className: styles.chatSecurityInput, style: { width: "104px", flexShrink: "0", marginLeft: "0px" } },
                    React.createElement(LineInput, { isSenseBox: true, inputStyle: { background: "#FFFFFF", height: "38px" }, value: bpModelId, onChange: (val) => {
                            dispatch(chatGPTReducer.updateModelId(val));
                        } })))))));
};
